<template>
  <ul class="other-list list list-small">
    <!--<li class="other-item" v-if="isOwned">-->
      <!--<button type="button" class="list-item list-item_noline">-->
        <!--{{$t('things.headerSingle.publish')}}-->
        <!--<exit-icon :fill="'rgba(0, 82, 127, .4)'"></exit-icon>-->
      <!--</button>-->
    <!--</li>-->
    <!--<li class="other-item" v-if="isOwned">-->
      <!--<button type="button" class="list-item list-item_noline">-->
        <!--{{$t('things.headerSingle.data')}}-->
        <!--<bookmark-icon :fill="'rgba(0, 82, 127, .4)'"></bookmark-icon>-->
      <!--</button>-->
    <!--</li>-->
<!--    <li class="other-item" v-if="isOwned">-->
<!--      <button type="button"-->
<!--              @click="showChangePopup"-->
<!--              class="list-item list-item_noline">-->
<!--        {{$t('things.headerSingle.changeOwner')}}-->
<!--        <user-icon :fill="'rgba(0, 82, 127, .4)'"></user-icon>-->
<!--      </button>-->
<!--    </li>-->
    <!--<li class="other-item">-->
      <!--<button type="button"-->
              <!--@click="copyData(thing.source_connect_token)"-->
              <!--:class="{'list-item_underline': isOwned}"-->
              <!--class="list-item list-item_noline list-item_opacity ">-->
        <!--{{$t('things.headerSingle.copyToken')}}-->
        <!--<copy-icon :fill="'rgba(0, 82, 127, .4)'"></copy-icon>-->
      <!--</button>-->
    <!--</li>-->
    <li class="other-item">
      <button type="button"
              @click="copyData(thing.id)"
              class="list-item list-item_noline list-item_opacity">
        {{$t('things.headerSingle.copyId')}}
        <copy-icon :fill="'rgba(0, 82, 127, .4)'"></copy-icon>
      </button>
    </li>
    <transition name="fade">
      <li v-show="show" class="copy-item">
          {{$t('labels.coped')}}
      </li>
    </transition>
  </ul>
</template>

<script>
  import exitIcon from '../../../../Svg/sidebar/logout'
  import bookmarkIcon from '../../../../Svg/things/bookmarkIIcon'
  import userIcon from '../../../../Svg/users/user'
  import copyIcon from '../../../../Svg/things/copyIcon'
  import {mapState, mapMutations} from 'vuex'
  import {showOverlay} from "../../../../../mixins/utils/showOverlay";

  export default {
    name: 'thingOtherMenu',
    mixins: [showOverlay],
    components: {
      exitIcon,
      bookmarkIcon,
      userIcon,
      copyIcon
    },
    data() {
      return {
        show: false
      }
    },
    computed: {
      ...mapState({
        thing: state => state.things.device
      }),
      isOwned() {
        return this.thing.permissions
      }
    },
    methods: {
      ...mapMutations({
        showChangeOwner: 'things/SET_SHOW_CHANGE_OWNER',
      }),
      showChangePopup() {
        this.showOverlay(true);
        this.showChangeOwner(true);
      },
      copyData(data) {
        let text = document.createElement('input');
        text.value = data;
        document.body.appendChild(text);
        text.select();
        document.execCommand('copy');
        document.body.removeChild(text);
        this.show = true;
        setTimeout(() => this.show = false,2000)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .other-item {
    width: 260px;
  }

  svg {
    max-width: 14px;
  }

  .other-list {
    padding: 10px 0;
   // position: relative;
  }

  .copy-item {
    position: absolute;
    width: 130px;
    background: #D7E3EA;
    left: calc(50% - 65px);
    top: calc(100% + 7px);
    font-family: MM, Arial, sans-serif;
    font-size: 12px;
    letter-spacing: 0.25px;
    text-align: center;
    padding: 5px;
    border-radius: 2px;
    color: $darkBlue;

    &::before {
      content: '';
      position: absolute;
      width: 11px;
      height: 11px;
      background: #D7E3EA;
      transform: rotate(45deg);
      left: 43%;
      top: -5px
    }
  }
</style>
